import { ActionAudFilterDto, ActionAudPagedDto } from '@api/client';
import { createReducer } from '@reduxjs/toolkit';
import { saveAuditFiltersUsed, searchAuditActions } from './actions';

interface InitialState {
  auditActions: ActionAudPagedDto | undefined;
  auditFiltersUsed: ActionAudFilterDto | undefined;
}

const initialState: InitialState = {
  auditActions: undefined,
  auditFiltersUsed: undefined,
};

export const auditControllerReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(searchAuditActions.fulfilled, (state, action) => {
      state.auditActions = action.payload;
    })
    .addCase(saveAuditFiltersUsed, (state, action) => {
      state.auditFiltersUsed = action.payload;
    });
});
